import { render } from "./logoutPage.vue?vue&type=template&id=2d856e91&scoped=true"
import script from "./logoutPage.vue?vue&type=script&lang=js"
export * from "./logoutPage.vue?vue&type=script&lang=js"

import "./logoutPage.vue?vue&type=style&index=0&id=2d856e91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d856e91"]])

export default __exports__